import React from "react";
import { Instagram, Youtube } from "lucide-react";

const INSTRUCTOR_IMG =
  "https://customer-assets.emergentagent.com/job_tower-crane-pro/artifacts/kfetb1tg_ChatGPT%20Image%2030_01_2026%2C%2015_25_30.png";

export default function Instructor() {
  return (
    <section
      className="relative py-24 sm:py-32 bg-zinc-950 border-b border-white/10 overflow-hidden"
      data-testid="instructor-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative aspect-[4/5] bg-zinc-900 border border-white/10 overflow-hidden">
            <img
              src={INSTRUCTOR_IMG}
              alt="Kawan Oliveira - Operador de Grua Torre"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6">
              <div className="text-xs uppercase tracking-[0.3em] text-yellow-400 mb-1">Instrutor</div>
              <div className="font-display text-3xl text-white">KAWAN OLIVEIRA</div>
            </div>
            <div className="absolute top-6 right-6 warning-stripes w-16 h-3" />
          </div>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <div className="text-xs uppercase tracking-[0.3em] text-yellow-400 mb-3">O Teu Instrutor</div>
          <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[0.9]">
            APRENDE COM <br />
            <span className="text-yellow-400">QUEM VIVE</span>
            <br />
            A PROFISSÃO.
          </h2>
          <p className="mt-6 text-zinc-300 leading-relaxed max-w-xl text-lg">
            Kawan opera gruas em Portugal há{" "}
            <span className="text-white font-semibold">+5 anos</span> e partilha o conhecimento real
            que o mercado exige — sem teoria vazia, direto ao que funciona na obra.
          </p>
          <p className="mt-4 text-zinc-400 max-w-xl leading-relaxed">
            Começou como muitos dos alunos: jovem, imigrante, sem formação na área. Hoje comanda
            gruas em obras de referência em Portugal e criou o{" "}
            <span className="text-white">maior curso online de grua torre em língua portuguesa</span>
            . O mesmo caminho que ele fez — podes fazer tu.
          </p>

          <div className="mt-8 grid grid-cols-3 gap-4 max-w-md">
            <Stat value="+1.900" label="Alunos" />
            <Stat value="+50" label="Aulas" />
            <Stat value="5+" label="Anos obra" />
          </div>

          <div className="mt-8 flex flex-wrap gap-3 text-sm">
            <SocialPill icon={Instagram} value="41K" label="Instagram" />
            <SocialPill icon={TikTokIcon} value="14.9K · 97.7K gostos" label="TikTok" />
            <SocialPill icon={Youtube} value="1.74K" label="YouTube" />
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ value, label }) {
  return (
    <div className="border border-white/10 bg-black/40 p-4">
      <div className="font-display text-3xl text-yellow-400 leading-none">{value}</div>
      <div className="text-[11px] uppercase tracking-widest text-zinc-500 mt-2">{label}</div>
    </div>
  );
}

function SocialPill({ icon: Icon, value, label }) {
  return (
    <div className="inline-flex items-center gap-2 border border-white/10 bg-zinc-900/60 px-3 py-2">
      <Icon className="w-4 h-4 text-yellow-400" />
      <span className="text-white font-semibold">{value}</span>
      <span className="text-zinc-500 text-xs uppercase tracking-widest">{label}</span>
    </div>
  );
}

function TikTokIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M19.321 5.562a5.124 5.124 0 0 1-3.414-2.032A5.103 5.103 0 0 1 14.906.5h-3.27v13.48a3.125 3.125 0 1 1-2.202-2.983V7.666a6.416 6.416 0 1 0 5.471 6.341V8.45a8.397 8.397 0 0 0 4.905 1.576V6.754a5.106 5.106 0 0 1-.489-1.192Z" />
    </svg>
  );
}
